export const apiName: string = 'setores';
export const setoresRoute: string = 'setores';
export const setoresStorage: string = 'setores';
export const setoresModuleName: any = {plural: 'Setores', single: 'Setor'};

export const setoresQuery: any = {
  "where":{
    "ativo":true,
    "setor":{"regexp":"/REPLACEHERE/i"}
  },
  "order":"setor"
};



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/estruturas/setores/shared/data.service.ts
 **/